// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//  IMPORT DE ESTILOS
import './assets/portotemplate/vendor/bootstrap/css/bootstrap-portotemplate.css';
import './assets/portotemplate/vendor/font-awesome/css/font-awesome.min.css';
import './assets/portotemplate/vendor/animate/animate.min.css';
import './assets/portotemplate/vendor/simple-line-icons/css/simple-line-icons.min.css';
import './assets/portotemplate/css/theme-portotemplate.css';
import './assets/portotemplate/css/theme-elements.css';
import './assets/portotemplate/css/theme-blog.css';
import './assets/portotemplate/css/theme-shop.css';
import './assets/portotemplate/css/color-sato.css';
import './assets/portotemplate/css/skins/default.css';
import './assets/portotemplate/css/demos/demo-shop-4.css';
import './assets/portotemplate/css/custom.css';
import 'vuesax/dist/vuesax.css';
import SocialSharing from 'vue-social-sharing';

import './assets/js/scrollTo.js';
import './assets/js/saladisputa.js';
import './assets/js/configUrl-npm.js';
import configFirebase from '../config/configuracao-Firebase.json';
import firebase from 'firebase/app';
import 'firebase/database';
import {getClockState, initClockSync} from './services/clock';

import Vue from 'vue';
import App from './App';
import VModal from 'vue-js-modal';
import router from './router';
import money from 'v-money';
import {detect} from 'detect-browser';
import bluebird from 'bluebird';
import Vuesax from 'vuesax';

Vue.config.productionTip = false;
Vue.config.NODE_ENV = typeof process.env.NODE_ENV !== 'undefined' ? process.env.NODE_ENV : 'production';
Vue.prototype.$clock = getClockState();

Vue.use(money, {precision: 4})
  .use(VModal, {dialog: true})
  .use(Vuesax)
  .use(SocialSharing)
  .filter('formatNumberMoney', function (value) {
    let val = (value / 1).toFixed(2).replace('.', ',')
    return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  })


// UTILIZAR MIXINS PARA FUNCTIONS(globais) QUE SERÃO REPETIDAS NOS COMPONENTS
const mixins = {
  methods: {
    MensagemBrowserCookie: function () {
      const browser = detect();
      var version = browser.version.split(".");
      version = version[0];

      let browserAntigo = false
      /*
        Browsers testados

        name:"chrome",
        version:"64.0.3282"

        name: "firefox",
        version: "58.0.0"

        name: "edge",
        version: "16.16299.0"

        name: "safari",
        version: "11.0.1"

      */
      if (browser.name == 'chrome') {
        if (version < 64) {
          browserAntigo = true
        }
      } else if (browser.name == 'firefox') {
        if (version < 48) {
          browserAntigo = true
        }
      } else if (browser.name == 'edge') {
        if (version < 16) {
          browserAntigo = true
        }
      } else if (browser.name == 'safari') {
        if (version < 11) {
          browserAntigo = true
        }
      }

      if (browserAntigo) {  // MENSAGEM BROWSER DESATUALIZADO.
        this.$modal.show('dialog', {
          title: `Atualização necessária`,
          text: `<p>
              Prezado cliente, nossa plataforma de leilões está homologada para versões de browser <strong>16.16 Edge</strong>, <strong>58.0 Firefox</strong>, <strong>64.0 Chrome</strong> e <strong>11.0 Safari</strong> ou superiores. </p>
              <p>Porém identificamos que atualmente você não está utilizando nenhuma dessas versões. </p>
              <p>Para uma melhor experiência de navegação em nossa plataforma, atualize seu browser atual ou utilize algum outro compatível. </p>
              <p>Sua versão atual é: <strong>${browser.name}</strong> - <strong>${browser.version}</strong></p>
              <p>Obrigado e boas compras!</p>`,
          buttons: [
            {
              title: 'Fechar',
              handler: () => {
                this.$modal.hide('dialog')
              }
            }
          ]
        })
      }

      if (navigator.cookieEnabled == false && browserAntigo == false) { // MENSAGEM ATIVAÇÃO DE COOKIES
        this.cookieAtivo = false
        this.$modal.show('dialog', {
          title: `Ativação de cookie necessária`,
          text: `<p>Para navegar nessa plataforma é preciso ativar os cookies de seu navegador.</p>
              <p>Obrigado e boas compras!</p>`,
          buttons: [
            {
              title: 'Fechar',
              handler: () => {
                this.$modal.hide('dialog')
              }
            }
          ]
        })
      }
    },
    formatarPreco(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    decodeHtml(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    refreshParcelamento(lote, lance = null) {
      var parcela = 0;

      if (lote.vl_parcelaminima > 0) {
        var valor = lance != null ? lance : lote.vl_lance_sugerido;
        valor = valor.replace(/\./g, "").replace("R$ ", "").replace(",", ".");
        var valor_entrada = valor * (lote.nu_limitepercentuallote / 100);
        var valor_parcelado = valor - valor_entrada;
        parcela = valor_parcelado / lote.vl_parcelaminima;
        parcela = Math.trunc(parcela > lote.nu_limiteparcelaslote ? lote.nu_limiteparcelaslote : parcela);
      } else {
        parcela = lote.nu_limiteparcelaslote
      }

      return parcela > 0 ? parcela : 1;
    }
  }
}


import('firebase/app').then((firebase) => {
  const firebaseApp = firebase.default;

  import('firebase/database')
    .then(() => {

      var fbConfig = '';
      if (window.location.hostname.indexOf('vue') != -1) {
        //Devs
        var fbConfig = configFirebase['development'];
        var urlConfig = window.location.hostname.split(".");

        if (urlConfig[1] == 'thaisteixeiraleiloes')
          urlConfig[1] = 'leiloesjudiciaismg';

        fbConfig.databaseURL = "https://" + urlConfig[0] + "-serrano-dev-" + urlConfig[2] + ".firebaseio.com/"

      } else if (window.location.hostname.indexOf('vlance-dev') != -1) {
        var fbConfig = configFirebase['development'];
        var urlConfig = window.location.hostname.split(".");

        if (urlConfig[1] == 'thaisteixeiraleiloes')
          urlConfig[1] = 'leiloesjudiciaismg';

        fbConfig.databaseURL = "https://" + urlConfig[0] + "-serrano-dev-" + urlConfig[1] + ".firebaseio.com/";

      } else if (window.location.hostname.indexOf('teste') != -1) {
        var fbConfig = configFirebase['homologacao'];
        var urlConfig = window.location.hostname.split(".");

        if (urlConfig[1] == 'thaisteixeiraleiloes')
          urlConfig[1] = 'leiloesjudiciaismg';

        fbConfig.databaseURL = "https://serrano-vlance-homo-" + urlConfig[1] + ".firebaseio.com/"
      } else {
        var fbConfig = configFirebase['production'];
        var urlConfig = window.location.hostname.split(".");
        let leiloeiro = urlConfig[0];
        if (urlConfig[0] == 'www') {
          leiloeiro = urlConfig[1];
        }
        if (urlConfig[0] == 'www3') {
          leiloeiro = urlConfig[1];
        }
        //Paliativo para troca de dominio (firebase).
        if (leiloeiro === 'leiloesjudiciaismgnorte')
          leiloeiro = 'leiloesjudiciais-mgnorte';
        if (leiloeiro === 'rigolonleiloes' || leiloeiro === 'leiloesrodrigorigolon')
          leiloeiro = 'rigolon-leiloes';
        if (leiloeiro === 'mariafixerleiloes')
          leiloeiro = 'mariafixer-leiloes';
        if (leiloeiro === 'planaltoleiloes')
          leiloeiro = 'planalto-leiloes';
        if (leiloeiro === 'nortenordesteleiloes')
          leiloeiro = 'cearaleiloes';
        if (leiloeiro === 'franciscofreitasleiloes')
          leiloeiro = 'cearaleiloes';
        if (leiloeiro === 'doleiloes')
          leiloeiro = 'danieloliveiraleiloes';
        if (leiloeiro === 'jrleiloes')
          leiloeiro = 'leiloesjudiciaissul';
        if (leiloeiro === 'leiloeszanoni')
          leiloeiro = 'leiloesjudiciaissc';
        if (leiloeiro === 'joserodovalholeiloes')
          leiloeiro = 'leiloesjudiciais-mgnorte';
        if (leiloeiro === 'superaleiloes')
          leiloeiro = 'supera-leiloes';
        if (leiloeiro === 'leiloesfabioguimaraes')
          leiloeiro = 'fabioleiloes';
        if (leiloeiro === 'hd')
          leiloeiro = 'hdleiloes';
        if (leiloeiro == 'thaisteixeiraleiloes')
          leiloeiro = 'leiloesjudiciaismg';
        if (leiloeiro == 'leiloesserrano')
          leiloeiro = 'sobrasdosleiloesdeimoveis';
        if (leiloeiro == 'perinileiloes')
          leiloeiro = 'pantanalleiloesjudiciais';
        if (leiloeiro == 'rosioliveiraleiloes')
          leiloeiro = 'dmleiloesjudiciais';
        // ->
        fbConfig.databaseURL = "https://serrano-vlance-" + leiloeiro + ".firebaseio.com/"
      }

      firebaseApp.initializeApp(fbConfig);
      initClockSync();

      new Vue({
        el: '#app',
        router,
        components: {App},
        template: '<App/>',
        mixins: [mixins],
        created: function () { // ADD VARIAVEIS GLOBAIS NO vm
          this.cookieAtivo = true;
          this.bluebird = bluebird;
          Vue.prototype.firebase_db = firebaseApp.database()
        }
      })
    });
});



// WEBPACK FOOTER //
// ./src/main.js